import { ThemeOptions } from '@mui/material';
import { grey } from '@mui/material/colors';
import type {} from '@mui/x-data-grid-pro/themeAugmentation';

const luzmoBackgroundColor = 'rgb(242, 242, 242)';
const formControl = '#4d4d4d';

const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    common: { black: '#000', white: '#fff' },
    primary: {
      light: '#223854',
      main: '#0e243c',
      dark: '#0E243C',
      contrastText: '#fff',
    },
    secondary: {
      light: '#29af99',
      main: '#00A088',
      dark: '#00937b',
      contrastText: '#fff',
    },
    info: { main: '#415058' },
    success: {
      light: '#80D0C4',
      main: '#5DB431',
    },
    error: { main: '#C91D1D' },
    warning: { main: '#E8A530' },
    text: {
      primary: '#495058',
      secondary: '#BBBDC0',
    },
    background: {
      paper: '#fff',
      default: luzmoBackgroundColor,
    },
  },
  typography: {
    fontFamily: 'Karla',
    caption: {
      color: grey[800],
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          overflow: 'visible',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-mainContent': {
            height: '100%', // Ensures Safari table rows fill page height.
          },
          '& .MuiDataGrid-pinnedColumnHeaders': {
            paddingRight: '0px !important', // Remove the padding-right in Chrome browsers
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
          },
          '& .MuiDataGrid-cell--editing .MuiInputBase-root': {
            backgroundColor: grey[200],
            width: '100%',
            borderRadius: '4px',
          },
          '& .MuiDataGrid-row--editing .MuiDataGrid-cell--editing input': {
            textAlign: 'center',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.MuiInputLabel-shrink': {
            color: formControl,
          },
        },
      },
    },
  },
};

export default themeOptions;
